// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2PTz8","footer":"styles_footer__2q96g","passCodeTooltip":"styles_passCodeTooltip__3QshJ"};